// English to Hindi translations
export const translations = {
  en: {
    // Navigation
    home: "Home",
    services: "Services",
    doctor: "Doctor",
    facilities: "Facilities",
    contact: "Contact",
    bookAppointment: "Book Appointment",

    // Top Bar
    phone: "Phone",
    email: "Email",
    location: "Location",
    mumbai: "Mumbai, Maharashtra",

    // Hero Section
    expertCare: "Expert Care for Your Digestive Health",
    welcomeText:
      "Welcome to Dr. Ashok Gastro & Liver Hospital - your trusted partner in gastroenterology and liver care. We provide comprehensive, compassionate care using the latest medical advances to ensure the best outcomes for our patients.",
    callNow: "Call Now",

    // Hero Badge & Stats
    trustedCare: "Trusted Gastroenterology Care",
    yearsExperience: "Years Experience",
    patientsTreated: "1 Lakh+ Patients Treated",
    procedures: "Procedures",

    // Hero Floating Cards
    ratingLabel: "4.5 / 5 Rating",
    trustedPatients: "Trusted by 50,000+ patients",
    emergencyLabel: "24/7 Emergency",
    alwaysAvailable: "Always available for you",

    // Services
    ourServices: "Our Services",

    // Booking extras
    age: "Age",
    gender: "Gender",
    enterAge: "Enter age",
    selectGender: "Select gender",
    male: "Male",
    female: "Female",
    other: "Other",
    successNotification: "You will be notified via email once doctor approves the request",
    servicesSubtitle:
      "Comprehensive gastroenterology and liver care services delivered with expertise and compassion",
    endoscopy: "Endoscopy",
    endoscopyDescription:
      "Advanced diagnostic procedure to examine the digestive tract using a flexible camera for accurate evaluation.",
    colonoscopy: "Colonoscopy",
    colonoscopyDescription:
      "Comprehensive examination of the colon to detect, prevent, and treat colorectal diseases at an early stage.",
    ercp: "ERCP",
    ercpDescription:
      "Specialized procedure for diagnosing and treating bile duct and pancreatic disorders.",
    biopsy: "Biopsy",
    biopsyDescription:
      "Safe and precise tissue sampling technique for accurate diagnosis of gastrointestinal conditions.",
    varicealLigation: "Variceal Ligation",
    varicealLigationDescription:
      "Effective endoscopic treatment to control and prevent bleeding from esophageal varices.",
    foreignBodyRemoval: "Foreign Body Removal",
    foreignBodyRemovalDescription:
      "Quick and safe removal of ingested or obstructive foreign objects from the digestive tract.",
    enteralMetalStenting: "Enteral Metal Stenting",
    enteralMetalStentingDescription:
      "Minimally invasive procedure to relieve obstructions in the digestive tract and restore normal flow.",
    pegPlacement: "PEG Placement",
    pegPlacementDescription:
      "Procedure for long-term nutritional support through direct feeding into the stomach.",
    polypectomy: "Polypectomy",
    polypectomyDescription:
      "Removal of abnormal growths in the gastrointestinal tract to prevent cancer development.",
    hemoclipApplication: "Hemoclip Application",
    hemoclipApplicationDescription:
      "Endoscopic technique to control internal bleeding using specialized clipping devices.",
    estUlcer: "EST of Ulcer",
    estUlcerDescription:
      "Advanced endoscopic management for treating and controlling bleeding ulcers.",
    strictureDilatation: "Stricture Dilatation",
    strictureDilatationDescription:
      "Procedure to widen narrowed digestive tract sections and improve swallowing or passage.",
    varicealGlueInjection: "Variceal Glue Injection",
    varicealGlueInjectionDescription:
      "Specialized treatment using medical glue to control bleeding from gastric varices.",
    expertTreatment: "Expert treatment with modern equipment",

    // Doctor
    ourDoctor: "Our Doctor",
    drAshok: "Dr. Ashok Kumar",
    specialty: "MD, Gastroenterology & Hepatology",
    mdDmGastro: "MD (Internal Medicine) · DM (Gastroenterology)",
    experienceYears: "15+ years experience in Gastroenterology and Hepatology",
    accreditations: "MBBS · MD (Internal Medicine), Chandigarh · DM (Gastroenterology), Ludhiana",
    specialProcedures:
      "Specialist in ERCP, EUS, and advanced endoscopic procedures",
    patientFirst: "Patient-first approach with best outcomes for every case",
    docDescription:
      "Dr. Ashok Kumar is a highly skilled gastroenterologist dedicated to providing exceptional care for patients with digestive and liver disorders. With a patient-first approach and extensive expertise, he ensures the best possible outcomes for every individual.",
    scheduleTitle: "Consultation Schedule",
    scheduleDetails: "Mon - Sun: 24/7 Emergency Available",
    bookSchedule: "Book Appointment",

    // Facilities
    ourFacilities: "Our Facilities",
    facilitiesSubtitle:
      "State-of-the-art medical infrastructure and world-class facilities",

    // Facility Cards
    facilityOTTitle: "Advanced Operation Theater",
    facilityOTDesc:
      "Modern surgical facility equipped with the latest technology for minimally invasive procedures.",
    facilityConsultTitle: "Consultation Rooms",
    facilityConsultDesc:
      "Comfortable and private consultation rooms for personalized patient care.",
    facilityWaitingTitle: "Patient Waiting Area",
    facilityWaitingDesc:
      "Spacious and comfortable waiting area designed for patient comfort.",
    facilityEmergencyTitle: "Emergency Services",
    facilityEmergencyDesc:
      "24/7 emergency medical assistance with a dedicated trauma team and life-support equipment.",
    facilityReceptionTitle: "Reception & Front Desk",
    facilityReceptionDesc:
      "Friendly and efficient reception staff to assist you with appointments and queries.",
    facilityTeamTitle: "Expert Medical Team",
    facilityTeamDesc:
      "Dedicated team of experienced gastroenterologists and healthcare professionals.",
    facilityHduTitle: "HDU & ICU Facility",
    facilityHduDesc:
      "Advanced High Dependency Unit (HDU) and Intensive Care Unit (ICU) equipped with modern life-support systems.",
    facilityLabTitle: "24×7 Laboratory",
    facilityLabDesc:
      "Fully equipped laboratory services available round the clock for quick and accurate diagnostic reports.",
    facilityPharmacyTitle: "24×7 Pharmacy",
    facilityPharmacyDesc:
      "In-house pharmacy open 24/7, providing easy access to essential medicines without delays.",
    facilityParkingTitle: "Free Parking",
    facilityParkingDesc:
      "Spacious and secure parking facility available free of cost for patients and visitors.",

    // Contact
    contactUs: "Contact Us",
    getDirections: "Get Directions",
    india: "India",
    Address: "Address",
    Phone: "Phone",
    Email: "Email",
    Hours: "Hours",
    addressDetails:
      "Shree Nath Plaza, Mohindergarh - Rewari Rd, opposite Bus Stand, Mamraj Colony, Maharana Partap Nagar, Narnaul, Haryana 123001",
    phoneDetails: "+91 9996504991",
    emailDetails: "drashokgastrolivercentre@gmail.com",
    hoursDetails:
      "Mon-Sun: 24/7 Emergency Available",

    // Book Appointment
    bookAppointmentTitle: "Book Your Appointment",
    scheduleConsultation:
      "Schedule a consultation with our expert doctors",
    fullName: "Full Name",
    emailAddress: "Email Address",
    phoneNumber: "Phone Number",
    preferredDate: "Preferred Date",
    preferredTime: "Preferred Time",
    describeYourProblem: "Describe Your Problem",
    enterFullName: "Enter your full name",
    enterEmail: "Enter your email",
    enterPhone: "Enter your phone number",
    enterProblem: "Please describe your medical condition or concern",
    submit: "Book Appointment",
    backToHome: "Back to Home",
    appointmentBooked: "Appointment booked successfully!",
    bookingFailed: "Failed to book appointment",
    bookingError: "Error booking appointment: ",

    // Confirmation Popup
    confirmTitle: "Confirm Your Appointment",
    confirmMessage: "Are you sure you want to book this appointment?",
    confirmYes: "Yes, Confirm",
    confirmNo: "Cancel",
    successTitle: "Appointment Confirmed!",
    successMessage:
      "Your appointment request has been received and is under review. We will email you a final confirmation within 30 minutes.",
    successClose: "OK, Got it!",

    // Admin Login
    adminLogin: "Admin Login",
    adminPortal: "Admin Portal",
    username: "Username",
    password: "Password",
    login: "Login",
    loggingIn: "Logging in...",
    invalidCredentials: "Invalid username or password",
    demo: "Demo",
    demoUsername: "admin",
    demoPassword: "admin123",
    backToLogin: "Back to Home",

    // Dashboard
    dashboard: "Dashboard",
    manageAppointments: "Manage Appointments",
    logout: "Logout",
    loading: "Loading appointments...",
    totalAppointments: "Total Appointments",
    confirmed: "Confirmed",
    pending: "Pending",
    allAppointments: "All Appointments",
    noAppointments: "No appointments booked yet.",
    name: "Name",
    completed: "Completed",
    cancelled: "Cancelled",
    status: "Status",
    action: "Action",
    problem: "Problem",
    time: "Time",
    date: "Date",
    noData: "No data",

    // Footer
    excellenceInCare: "Excellence in Gastroenterology Care",
    hospitalDescription:
      "Providing comprehensive and compassionate care for digestive health and liver diseases.",
    quickLinks: "Quick Links",
    contactInfo: "Contact Info",
    followUs: "Follow Us",
    allRightsReserved: "All rights reserved.",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    disclaimer: "Disclaimer",
    footerTagline: "Your trusted partner for digestive & liver health",
    copyright: "© 2025 Dr. Ashok Gastro & Liver Hospital. All rights reserved.",

    // Footer Hours Labels
    footerMonFri: "Mon – Fri",
    footerSaturday: "Saturday",
    footerSunday: "Sunday",
    footerEmergency: "Emergency",
    footerEmergencyTime: "24 / 7",

    // Footer Brand
    footerBrandMain: "Dr. Ashok Gastro",
    footerBrandSub: "& Liver Hospital",
    footerCity: "Narnaul, Haryana 123001",

    // About Page
    aboutUs: "About Us",
    aboutPageTitle: "About Dr. Ashok Gastro & Liver Hospital",
    aboutPageSubtitle: "A premier multi-speciality gastroenterology centre in Narnaul, Haryana",
    missionTitle: "Our Mission",
    missionText: "To provide world-class gastroenterology and liver care that is accessible, compassionate, and evidence-based — ensuring every patient receives the best possible outcome.",
    visionTitle: "Our Vision",
    visionText: "To be the most trusted gastroenterology centre in Haryana, recognized for clinical excellence, patient-centered care, and continuous innovation in digestive health.",
    directorsMessage: "Director's Message",
    directorsMessageFull: "At Dr. Ashok Gastro & Liver Hospital, our commitment goes beyond treating diseases — we care for people. Every patient who walks through our doors deserves the highest standard of medical care delivered with empathy and respect. Over the past 15 years, we have built a team and infrastructure that I am truly proud of. Our mission is simple: to heal, to comfort, and to serve.",
    directorsQuote: "Our patients are our priority. Every decision we make is guided by their well-being and trust.",
    readFullMessage: "Read Full Message",
    valueExcellence: "Excellence",
    valueExcellenceDesc: "Uncompromising standards in clinical care and patient safety.",
    valueCompassion: "Compassion",
    valueCompassionDesc: "Treating every patient with empathy, dignity, and respect.",
    valueInnovation: "Innovation",
    valueInnovationDesc: "Embracing the latest medical technology and evidence-based practices.",
    valueIntegrity: "Integrity",
    valueIntegrityDesc: "Honest, transparent, and ethical in all our interactions.",
    accreditationsTitle: "Accreditations & Recognition",

    // Team Page
    teamPageTitle: "Our Medical Team",
    teamPageSubtitle: "A dedicated team of healthcare professionals committed to your well-being",
    teamDoctorNote: "For Dr. Ashok Kumar's detailed profile, visit our",
    teamDoctorPage: "Doctor Page",
    teamMedical: "Medical Team",
    teamClinical: "Clinical Support",
    teamPharmacy: "Pharmacy",
    teamNursing: "Nursing Team",
    teamAdmin: "Administration",
    teamSupport: "Support Staff",
    gastroIntensivist: "Gastro Intensivist",
    gastroIntensivistDesc: "Specialized in critical care management for gastroenterology patients.",
    residentDoctor: "Resident Doctor",
    residentDoctorDesc: "Providing round-the-clock medical supervision and patient care.",
    otTechnician: "OT Technician",
    otTechnicianDesc: "Expert in operation theater setup and surgical assistance.",
    labTechnician: "Lab Technician",
    labTechnicianDesc: "Conducting accurate diagnostic tests and laboratory analysis.",
    pharmacist: "Pharmacist",
    pharmacistDesc: "Ensuring safe and accurate dispensing of medications.",
    nursingStaff: "Nursing Staff",
    nursingStaffDesc: "20+ dedicated nurses providing compassionate bedside care.",
    generalManager: "General Manager",
    generalManagerDesc: "Overseeing hospital operations and administrative functions.",
    receptionist: "Receptionist",
    receptionistDesc: "First point of contact for patients and visitors.",
    supportStaffDesc: "Housekeeping, security, and maintenance ensuring a clean, safe environment.",

    // Services Page
    servicesPageTitle: "Our Services",
    servicesPageSubtitle: "Comprehensive gastroenterology and liver care services",
    backToServices: "Back to Services",
    whatToExpect: "What to Expect",
    procedureSteps: "Procedure Steps",
    benefits: "Benefits",
    bookNow: "Book Appointment",

    // Facilities Page
    facilitiesPageTitle: "Our Facilities",
    facilitiesPageSubtitle: "State-of-the-art infrastructure for world-class care",
    backToFacilities: "Back to Facilities",
    relatedFacilities: "Related Facilities",
    facilityFeatures: "Key Features",

    // Doctor Page
    doctorPageTitle: "Dr. Ashok Kumar",
    doctorPageSubtitle: "MD (Internal Medicine), Chandigarh · DM (Gastroenterology), Ludhiana — Senior Consultant & Director",
    education: "Education",
    experience: "Experience",
    specializations: "Specializations",
    awardsRecognition: "Awards & Recognition",
    publications: "Publications & Research",
    consultationSchedule: "Consultation Schedule",
    proceduresPerformed: "Procedures Performed",
    bookConsultation: "Book Consultation",

    // Mission & Vision section on landing
    missionVisionTitle: "Mission & Vision",
    missionVisionSubtitle: "Guided by purpose, driven by excellence",

    // Director Page
    directorsDesk: "From the Director's Desk",
    directorsMessageTitle: "Director's Message",
    viewFullProfile: "View Full Profile",
    bookAppointmentBtn: "Book Appointment",
    dirMsgPara1: "At Dr. Ashok Gastro & Liver Hospital, our commitment goes beyond clinical excellence. We believe every patient deserves compassionate, transparent, and evidence-based care. Our team of dedicated professionals works tirelessly to ensure that each visit is comfortable, dignified, and effective.",
    dirMsgPara2: "Over the past 15 years, we have had the privilege of serving over 1 lakh patients from across Haryana and neighboring states. This trust is our greatest achievement and our strongest motivation to keep improving.",
    dirMsgPara3: "We continue to invest in the latest endoscopic technology, ongoing medical education, and patient-centered processes — because you deserve nothing less than the best.",
    dirClosingTitle: "MD (Internal Medicine) · DM (Gastroenterology)",
    dirClosingRole: "Director & Senior Consultant, Dr. Ashok Gastro-Liver Hospital",

    // About Page
    ourStory: "Our Story",
    trustedNameTitle: "A Trusted Name in",
    gastroCareSub: "Gastroenterology Care",
    yearsOfExcellence: "Years of Excellence",
    yearsExperienceLbl: "Years Experience",
    patientsTreatedLbl: "Patients Treated",
    emergencyCareLbl: "Emergency Care",
    ourValuesEyebrow: "Our Values",
    whatWeStandFor: "What We Stand For",
    readyWorldClassCare: "Ready to Experience World-Class Care?",
    bookConsultationToday: "Book your consultation with Dr. Ashok Kumar today.",
    callNowBtn: "Call Now",
    aboutPara1: "Dr. Ashok Gastro & Liver Hospital is a premier multi-speciality gastroenterology centre in Narnaul, Haryana. Founded and led by Dr. Ashok Kumar (MD, DM Gastroenterology), we have been providing comprehensive digestive and liver care for over 15 years using the latest medical technology and evidence-based practices.",
    aboutPara2: "Our hospital is committed to the highest standards of patient care, safety, and clinical excellence. We are dedicated to making world-class gastroenterology care accessible to every patient in the region.",

    // Doctor Page
    academicQualifications: "Academic Qualifications",
    achievementsMemberships: "Achievements & Memberships",
    consultationHours: "Consultation Hours",
    readyToConsult: "Ready to Consult Dr. Ashok Kumar?",
    bookAppointmentToday: "Book your appointment today and get expert gastroenterology care.",
    yearsExpLbl: "Years Exp.",
    proceduresLbl: "Procedures",
    patientsLbl: "Patients",
    callNowAction: "Call Now",
    ach1: "15+ years of dedicated practice in Gastroenterology & Hepatology",
    ach2: "Performed over 10,000+ endoscopic procedures",
    ach3: "Regular speaker at regional CME programs",
    ach4: "Recognized for excellence in patient care by Haryana Medical Council",
    edu1Degree: "MBBS",
    edu1Inst: "Government Medical College, Rohtak",
    edu2Degree: "MD – Internal Medicine",
    edu2Inst: "Government Medical College and Hospital, Chandigarh",
    edu3Degree: "DM – Gastroenterology",
    edu3Inst: "Dayanand Medical College and Hospital, Ludhiana",
    schMornType: "Morning OPD",
    schEvenType: "Evening OPD",
    schSunType: "By Appointment",
    schEmerType: "Emergency",
    schMonSat: "Mon – Sat",
    schSunday: "Sunday",
    schAllDays: "All Days",

    // Team Page
    ourPeople: "Our People",
    ourTeamBreadcrumb: "Our Team",
    healthcareTeamEyebrow: "Healthcare Team",
    meetOurTeam: "Meet Our Team",
    clickDeptHint: "Click a department to see all team members",
    memberSingular: "Member",
    memberPlural: "Members",
    clickViewMembers: "Click to view all members →",
    experienceCareTitle: "Experience Care from Our Expert Team",
    experienceCareDesc: "Book an appointment and let our dedicated professionals take care of you.",

    // Book Appointment Page
    appointmentsEyebrow: "Appointments",
    bookAnAppointment: "Book an Appointment",
    bookSubtitle: "Choose how you'd like to book your consultation with Dr. Ashok Kumar",
    instantBadge: "Instant",
    onlineBadge: "Online",
    callNowTitle: "Call Now",
    callNowDesc: "Speak directly with our reception team to book your appointment instantly. Available during clinic hours.",
    monSatHours: "Mon–Sun: 9 AM – 5 PM | 5 PM – 8 PM OPD Emergency",
    emergency247: "Emergency: 24/7",
    callNumber: "Call +91 9996504991",
    bookViaForm: "Book via Form",
    bookViaFormDesc: "Fill out our online appointment form. Our team will review your request and send a confirmation email once approved.",
    step1Text: "Fill the form with your details",
    step2Text: "Request is reviewed by admin",
    step3Text: "Confirmation email sent to you",
    pendingStatus: "Pending",
    confirmedStatus: "Confirmed ✓",
    openBookingForm: "Open Booking Form",
    formNote: "Opens in a new tab · Free · No login required",
    opdHours: "OPD Hours",
    opdHoursDetail: "Mon–Sun: 9 AM–5 PM | Emergency OPD: 5 PM–8 PM",
    emergencyLabel: "Emergency",
    emergency247Available: "24/7 Available",
    locationLabel: "Location",
    narnaul: "Narnaul, Haryana",

    // Team Dept Page
    backToTeam: "Back to Team",
    ourTeamEyebrow: "Our Team",
    otherDepartments: "Other Departments",

    // Navbar & shared UI
    bookEAppointment: "Book E-Appointment",
    emergencyColon: "Emergency:",
    callUs: "Call Us",
    emergency: "Emergency",
    available247: "24/7 Available",
    locationNav: "Location",
    narnaulHaryana: "Narnaul, Haryana",
    hospitalName: "Dr. Ashok Gastro-Liver Hospital",
    hospitalTagline: "A Multi Speciality Gastroenterology Hospital",
    allServicesArrow: "All Services ↓",
    allFacilitiesArrow: "All Facilities ↓",
    aboutUs2: "About Us",
    directorMessage: "Director Message",
    fromDrAshok: "From Dr. Ashok Kumar",
    ourStoryMission: "Our story & mission",
    upperGIExam: "Upper GI examination",
    colonScreening: "Colon screening",
    bileDuctProc: "Bile duct procedures",
    tissueSampling: "Tissue sampling",
    bleedingControl: "Bleeding control",
    safeRetrieval: "Safe object retrieval",
    stentTherapy: "Stent placement therapy",
    feedingTube: "Feeding tube insertion",
    polypRemoval: "Polyp removal",
    bleedingClipping: "Bleeding site clipping",
    ulcerTreatment: "Ulcer treatment",
    narrowingCorrection: "Narrowing correction",
    advancedSurgical: "Advanced surgical suite",
    privateConsult: "Private consultation",
    patientLounge: "Comfortable patient lounge",
    emergencyCare247: "24/7 emergency care",
    patientReg: "Patient registration",
    roundClockTesting: "Round-the-clock testing",
    medicinesAvail: "Medicines always available",
    freeParkingDesc: "Free patient parking",
    allStaffMembers: "All staff members",
    teamLabel: "Team",
    doctorsLabel: "Doctors",
    ourMedicalTeam: "Our Medical Team",

    // LandingPage hardcoded
    yearsExperiencePill: "15+ Years Experience",
    heroTitlePart1: "Expert",
    heroTitleHighlight: "Gastro & Liver",
    heroTitlePart2: "Care",
    heroTitlePart3: "You Can Trust",
    expertGastroTitle: "Expert Gastro & Liver Care You Can Trust",
    heroHighlight: "Gastro & Liver",
    heroCareText: "You Can Trust",
    emergencyStatLbl: "Emergency",
    quickAppointment: "Quick Appointment",
    bookEAppointmentBtn: "Book E-Appointment",
    mdDmGastroTrust: "MD, DM Gastroenterologist",
    emergency247Services: "24/7 Emergency Services",
    patientRating: "4.5/5 Patient Rating",
    yearsOfExcellenceBadge: "Years of Excellence",
    aboutUsEyebrow: "About Us",
    trustedNameLanding: "A Trusted Name in",
    gastroCareLanding: "Gastroenterology Care",
    landingAboutPara1: "Dr. Ashok Gastro & Liver Hospital is a premier multi-speciality gastroenterology centre in Narnaul, Haryana. Led by Dr. Ashok Kumar (MD, DM Gastroenterology), we provide comprehensive digestive and liver care using the latest medical technology.",
    landingAboutPara2: "Our hospital is committed to the highest standards of patient care, safety, and clinical excellence, serving patients across Haryana and neighboring states.",
    yearsExperienceStat: "Years Experience",
    patientsTreatedStat: "Patients Treated",
    advancedEndoscopy: "Advanced Endoscopy Suite",
    emergency24ICU: "24/7 Emergency & ICU",
    inhouseLab: "In-house Lab & Pharmacy",
    compassionateCare: "Compassionate Patient Care",
    learnMore: "Learn More",
    viewDetails: "View Details",
    learnMoreLink: "Learn More",
    patientTestimonialsEyebrow: "Patient Testimonials",
    whatPatientsSay: "What Our Patients Say",
    viewAllGoogleReviews: "View All Google Reviews",
    googleReview: "Google Review",
    readyBookTitle: "Ready to Book Your Appointment?",
    readyBookDesc: "Get expert gastroenterology care from Dr. Ashok Kumar. Available 24/7 for emergencies.",

    // ServiceDetailPage hardcoded
    ourServicesEyebrow: "Our Services",
    aboutThisProcedure: "About This Procedure",
    bookThisProcedure: "Book This Procedure",
    scheduleConsultDesc: "Schedule a consultation with Dr. Ashok Kumar for expert evaluation.",
    doctorSidebarTitle: "Doctor",
    drAshokDeg: "MD (Internal Medicine) · DM (Gastroenterology)",
    viewProfile: "View Profile",
    otherServicesTitle: "Other Services",

    // FacilityDetailPage hardcoded
    ourFacilitiesEyebrow: "Our Facilities",

    // Footer hardcoded
    footerBrandName: "Dr. Ashok Gastro",
    footerBrandSub2: "and Liver Hospital",
    footerAboutUs: "About Us",
    footerDoctor: "Doctor",
    footerTeam: "Team",

    // Service subtitles
    endoscopySubtitle: "Advanced Diagnostic & Therapeutic Endoscopy",
    colonoscopySubtitle: "Complete Colon Examination",
    ercpSubtitle: "Endoscopic Retrograde Cholangiopancreatography",
    biopsySubtitle: "Precision Tissue Sampling",
    varicealLigationSubtitle: "Endoscopic Band Ligation",
    foreignBodyRemovalSubtitle: "Endoscopic Retrieval",
    enteralMetalStentingSubtitle: "Self-Expanding Metal Stent Placement",
    pegPlacementSubtitle: "Percutaneous Endoscopic Gastrostomy",
    polypectomySubtitle: "Endoscopic Polyp Removal",
    hemoclipApplicationSubtitle: "Endoscopic Hemostasis",
    estUlcerSubtitle: "Endoscopic Sclerotherapy",
    strictureDilatationSubtitle: "Endoscopic Dilation Therapy",

    // Service descriptions
    endoscopyDesc: "Upper GI endoscopy (OGD scopy) is a procedure that allows examination of the esophagus, stomach, and duodenum using a flexible camera for accurate evaluation.",
    colonoscopyDesc: "Comprehensive examination of the entire colon and rectum to detect polyps, cancer, and inflammatory bowel disease.",
    ercpDesc: "Specialized procedure combining endoscopy and fluoroscopy to diagnose and treat bile duct and pancreatic conditions.",
    biopsyDesc: "Safe and precise tissue sampling from the gastrointestinal tract for accurate pathological diagnosis.",
    varicealLigationDesc: "Effective endoscopic treatment to control and prevent life-threatening bleeding from esophageal varices.",
    foreignBodyRemovalDesc: "Safe and efficient removal of accidentally ingested foreign objects from the digestive tract.",
    enteralMetalStentingDesc: "Minimally invasive placement of metal stents to relieve obstructions in the esophagus, stomach, or colon.",
    pegPlacementDesc: "Endoscopic placement of a feeding tube directly into the stomach for long-term nutritional support.",
    polypectomyDesc: "Removal of abnormal growths (polyps) from the gastrointestinal tract to prevent cancer development.",
    hemoclipApplicationDesc: "Precise endoscopic technique using specialized clips to control gastrointestinal bleeding.",
    estUlcerDesc: "Advanced endoscopic injection therapy for treating and controlling bleeding from peptic ulcers.",
    strictureDilatationDesc: "Procedure to widen narrowed sections of the digestive tract to improve swallowing and food passage.",

    // Service benefits - Endoscopy
    endoscopyD1: "Diagnosis of ulcers, gastritis, GERD",
    endoscopyD2: "Detection of H. pylori infection",
    endoscopyD3: "Biopsy for cancer screening",
    endoscopyD4: "Treatment of bleeding lesions",
    // Colonoscopy
    colonoscopyD1: "Polyp detection and removal",
    colonoscopyD2: "Colorectal cancer screening",
    colonoscopyD3: "Diagnosis of IBD",
    colonoscopyD4: "Evaluation of rectal bleeding",
    // ERCP
    ercpD1: "Bile duct stone removal",
    ercpD2: "Stent placement for strictures",
    ercpD3: "Diagnosis of pancreatic disorders",
    ercpD4: "Treatment of biliary obstruction",
    // Biopsy
    biopsyD1: "Cancer diagnosis",
    biopsyD2: "H. pylori testing",
    biopsyD3: "Celiac disease diagnosis",
    biopsyD4: "IBD assessment",
    // Variceal Ligation
    varicealD1: "Emergency bleeding control",
    varicealD2: "Prevention of re-bleeding",
    varicealD3: "Portal hypertension management",
    varicealD4: "Liver cirrhosis complication treatment",
    // Foreign Body Removal
    foreignBodyD1: "Coin and button battery removal",
    foreignBodyD2: "Food bolus impaction",
    foreignBodyD3: "Sharp object retrieval",
    foreignBodyD4: "Pediatric and adult cases",
    // Enteral Metal Stenting
    enteralD1: "Esophageal cancer palliation",
    enteralD2: "Gastric outlet obstruction",
    enteralD3: "Colonic obstruction relief",
    enteralD4: "Biliary stenting",
    // PEG Placement
    pegD1: "Neurological conditions",
    pegD2: "Head and neck cancer",
    pegD3: "Swallowing disorders",
    pegD4: "Long-term nutritional support",
    // Polypectomy
    polypD1: "Colorectal polyp removal",
    polypD2: "Gastric polyp excision",
    polypD3: "Cancer prevention",
    polypD4: "Histopathological analysis",
    // Hemoclip Application
    hemoclipD1: "Peptic ulcer bleeding",
    hemoclipD2: "Post-polypectomy bleeding",
    hemoclipD3: "Dieulafoy lesion",
    hemoclipD4: "Mallory-Weiss tear",
    // EST of Ulcer
    estD1: "Active bleeding ulcers",
    estD2: "Visible vessel treatment",
    estD3: "Combination therapy",
    estD4: "Recurrence prevention",
    // Stricture Dilatation
    strictureD1: "Esophageal stricture",
    strictureD2: "Achalasia treatment",
    strictureD3: "Post-surgical strictures",
    strictureD4: "Peptic strictures",

    // Team department titles (for TeamDeptPage)
    deptMedical: "Medical Team",
    deptOT: "OT",
    deptClinical: "Lab",
    deptPharmacy: "Pharmacy",
    deptNursing: "Nursing Staff",
    deptAdmin: "Administration",
    deptSupport: "Support Staff",

    // Facility titles (for FacilityDetailPage)
    facilityOTFullTitle: "Advanced Operation Theater",
    facilityConsultFullTitle: "Consultation Rooms",
    facilityWaitingFullTitle: "Patient Waiting Area",
    facilityEmergencyFullTitle: "Emergency Services",
    facilityReceptionFullTitle: "Reception & Front Desk",
    facilityLabFullTitle: "24x7 Laboratory",
    facilityPharmacyFullTitle: "24x7 Pharmacy",
    facilityParkingFullTitle: "Free Parking",

    // Facility descriptions
    facilityOTFullDesc: "Our state-of-the-art Operation Theater is equipped with the latest laparoscopic and endoscopic technology, ensuring the highest standards of surgical care and patient safety.",
    facilityConsultFullDesc: "Private, well-equipped consultation rooms designed for comprehensive patient evaluation and confidential discussions.",
    facilityWaitingFullDesc: "Spacious, air-conditioned waiting area with comfortable seating and patient education materials to keep you informed.",
    facilityEmergencyFullDesc: "24/7 emergency medical services with dedicated trauma team and life-support equipment for immediate critical care.",
    facilityReceptionFullDesc: "Efficient reception with trained staff to assist with appointments, queries, and patient guidance throughout your visit.",
    facilityLabFullDesc: "Fully equipped laboratory with automated analyzers for quick and accurate diagnostic reports available round the clock.",
    facilityPharmacyFullDesc: "In-house pharmacy stocked with all essential medicines, open round the clock for your convenience.",
    facilityParkingFullDesc: "Spacious and secure parking facility available free of cost for all patients and visitors.",

    // Facility features
    facilityOTF1: "Laminar airflow system",
    facilityOTF2: "Advanced anesthesia workstation",
    facilityOTF3: "High-definition endoscopy tower",
    facilityOTF4: "Emergency crash cart",
    facilityOTF5: "Sterilization protocols as per NABH standards",
    facilityConsultF1: "Digital patient records",
    facilityConsultF2: "High-resolution diagnostic displays",
    facilityConsultF3: "Private and confidential environment",
    facilityConsultF4: "Comfortable seating for patients and attendants",
    facilityWaitingF1: "Air-conditioned comfort",
    facilityWaitingF2: "Patient education displays",
    facilityWaitingF3: "Drinking water facility",
    facilityWaitingF4: "Wheelchair accessible",
    facilityEmergencyF1: "24/7 availability",
    facilityEmergencyF2: "Dedicated trauma team",
    facilityEmergencyF3: "Advanced life support",
    facilityEmergencyF4: "Direct ICU access",
    facilityEmergencyF5: "Ambulance coordination",
    facilityReceptionF1: "Appointment scheduling",
    facilityReceptionF2: "Insurance assistance",
    facilityReceptionF3: "Patient guidance",
    facilityReceptionF4: "Multilingual staff",
    facilityLabF1: "Automated analyzers",
    facilityLabF2: "24/7 availability",
    facilityLabF3: "Quick turnaround time",
    facilityLabF4: "Digital report delivery",
    facilityLabF5: "Quality control protocols",
    facilityPharmacyF1: "24/7 availability",
    facilityPharmacyF2: "All essential medicines",
    facilityPharmacyF3: "Generic alternatives available",
    facilityPharmacyF4: "Prescription verification",
    facilityParkingF1: "Free of charge",
    facilityParkingF2: "CCTV surveillance",
    facilityParkingF3: "Wheelchair accessible entry",
    facilityParkingF4: "Ample space for vehicles",
  },

  hi: {
    // Navigation
    home: "होम",
    services: "सेवाएं",
    doctor: "डॉक्टर",
    facilities: "सुविधाएं",
    contact: "संपर्क",
    bookAppointment: "अपॉइंटमेंट बुक करें",

    // Top Bar
    phone: "फोन",
    email: "ईमेल",
    location: "स्थान",
    mumbai: "मुंबई, महाराष्ट्र",

    // Hero Section
    expertCare: "आपके पाचन स्वास्थ्य के लिए विशेषज्ञ देखभाल",
    welcomeText:
      "डॉ. अशोक गैस्ट्रो और लिवर हॉस्पिटल में आपका स्वागत है - गैस्ट्रोएंटेरोलॉजी और लिवर देखभाल में आपका विश्वसनीय साथी। हम अपने मरीजों के लिए सर्वोत्तम परिणाम सुनिश्चित करने के लिए नवीनतम चिकित्सा प्रगति का उपयोग करके व्यापक, दयालु देखभाल प्रदान करते हैं।",
    callNow: "अभी कॉल करें",

    // Hero Badge & Stats
    trustedCare: "विश्वसनीय गैस्ट्रोएंटेरोलॉजी देखभाल",
    yearsExperience: "वर्षों का अनुभव",
    patientsTreated: "1 लाख+ मरीज़ उपचारित",
    procedures: "प्रक्रियाएं",

    // Hero Floating Cards
    ratingLabel: "4.5 / 5 रेटिंग",
    trustedPatients: "50,000+ मरीजों का भरोसा",
    emergencyLabel: "24/7 आपातकालीन सेवा",
    alwaysAvailable: "हमेशा आपके लिए उपलब्ध",

    // Services
    ourServices: "हमारी सेवाएं",
    servicesSubtitle:
      "विशेषज्ञता और करुणा के साथ प्रदान की जाने वाली व्यापक गैस्ट्रोएंटेरोलॉजी और लिवर देखभाल सेवाएं",
    endoscopy: "एंडोस्कोपी",
    endoscopyDescription:
      "सटीक मूल्यांकन के लिए लचीले कैमरे का उपयोग करके पाचन तंत्र की जांच करने की उन्नत निदान प्रक्रिया।",
    colonoscopy: "कोलोनोस्कोपी",
    colonoscopyDescription:
      "प्रारंभिक अवस्था में कोलोरेक्टल रोगों का पता लगाने, रोकने और इलाज करने के लिए बृहदान्त्र की व्यापक जांच।",
    ercp: "ईआरसीपी",
    ercpDescription:
      "पित्त नली और अग्नाशय संबंधी विकारों के निदान और उपचार के लिए विशेष प्रक्रिया।",
    biopsy: "बायोप्सी",
    biopsyDescription:
      "जठरांत्र संबंधी स्थितियों के सटीक निदान के लिए सुरक्षित और सटीक ऊतक नमूनाकरण तकनीक।",
    varicealLigation: "वैरिकेल लिगेशन",
    varicealLigationDescription:
      "एसोफेजियल वैरिस से रक्तस्राव को नियंत्रित और रोकने के लिए प्रभावी एंडोस्कोपिक उपचार।",
    foreignBodyRemoval: "विदेशी वस्तु निष्कासन",
    foreignBodyRemovalDescription:
      "पाचन तंत्र से निगली गई या अवरोधक विदेशी वस्तुओं को जल्दी और सुरक्षित रूप से हटाना।",
    enteralMetalStenting: "एंटरल मेटल स्टेंटिंग",
    enteralMetalStentingDescription:
      "पाचन तंत्र में रुकावटों को दूर करने और सामान्य प्रवाह बहाल करने के लिए न्यूनतम आक्रामक प्रक्रिया।",
    pegPlacement: "पीईजी प्लेसमेंट",
    pegPlacementDescription:
      "पेट में सीधे भोजन के माध्यम से दीर्घकालिक पोषण सहायता के लिए प्रक्रिया।",
    polypectomy: "पॉलीपेक्टोमी",
    polypectomyDescription:
      "कैंसर के विकास को रोकने के लिए जठरांत्र संबंधी मार्ग में असामान्य वृद्धि को हटाना।",
    hemoclipApplication: "हेमोक्लिप एप्लीकेशन",
    hemoclipApplicationDescription:
      "विशेष क्लिपिंग उपकरणों का उपयोग करके आंतरिक रक्तस्राव को नियंत्रित करने की एंडोस्कोपिक तकनीक।",
    estUlcer: "अल्सर का ईएसटी",
    estUlcerDescription:
      "रक्तस्राव अल्सर के उपचार और नियंत्रण के लिए उन्नत एंडोस्कोपिक प्रबंधन।",
    strictureDilatation: "स्ट्रिक्चर डिलेटेशन",
    strictureDilatationDescription:
      "संकुचित पाचन तंत्र वर्गों को चौड़ा करने और निगलने या मार्ग को बेहतर बनाने की प्रक्रिया।",
    varicealGlueInjection: "वैरिकेल ग्लू इंजेक्शन",
    varicealGlueInjectionDescription:
      "गैस्ट्रिक वैरिस से रक्तस्राव को नियंत्रित करने के लिए मेडिकल ग्लू का उपयोग करके विशेष उपचार।",
    expertTreatment: "आधुनिक उपकरणों के साथ विशेषज्ञ उपचार",

    // Doctor
    ourDoctor: "हमारे डॉक्टर",
    drAshok: "डॉ. अशोक कुमार",
    specialty: "एमडी, गैस्ट्रोएंटेरोलॉजी और हेपेटोलॉजी",
    mdDmGastro: "MD (आंतरिक चिकित्सा) · DM (गैस्ट्रोएंटेरोलॉजी)",
    experienceYears: "गैस्ट्रोएंटेरोलॉजी और हेपेटोलॉजी में 15+ वर्षों का अनुभव",
    accreditations:
      "MBBS · MD (आंतरिक चिकित्सा), चंडीगढ़ · DM (गैस्ट्रोएंटेरोलॉजी), लुधियाना",
    specialProcedures:
      "ईआरसीपी, ईयूएस और उन्नत एंडोस्कोपिक प्रक्रियाओं में विशेषज्ञ",
    patientFirst: "हर मामले में सर्वोत्तम परिणामों के साथ रोगी-प्रथम दृष्टिकोण",
    docDescription:
      "डॉ. अशोक कुमार एक अत्यधिक कुशल गैस्ट्रोएंटेरोलॉजिस्ट हैं जो पाचन और लिवर विकारों वाले रोगियों के लिए असाधारण देखभाल प्रदान करने के लिए समर्पित हैं। रोगी-प्रथम दृष्टिकोण और व्यापक विशेषज्ञता के साथ, वे हर व्यक्ति के लिए सर्वोत्तम संभव परिणाम सुनिश्चित करते हैं।",
    scheduleTitle: "परामर्श अनुसूची",
    scheduleDetails:
      "सोम - रविवार: 24/7 आपातकालीन सेवा उपलब्ध",
    bookSchedule: "अपॉइंटमेंट बुक करें",

    // Facilities
    ourFacilities: "हमारी सुविधाएं",
    facilitiesSubtitle:
      "अत्याधुनिक चिकित्सा बुनियादी ढांचा और विश्व स्तरीय सुविधाएं",

    // Facility Cards
    facilityOTTitle: "उन्नत ऑपरेशन थिएटर",
    facilityOTDesc:
      "न्यूनतम आक्रामक प्रक्रियाओं के लिए नवीनतम तकनीक से सुसज्जित आधुनिक शल्य चिकित्सा सुविधा।",
    facilityConsultTitle: "परामर्श कक्ष",
    facilityConsultDesc:
      "व्यक्तिगत रोगी देखभाल के लिए आरामदायक और निजी परामर्श कक्ष।",
    facilityWaitingTitle: "मरीज़ प्रतीक्षा क्षेत्र",
    facilityWaitingDesc:
      "मरीजों की सुविधा के लिए डिज़ाइन किया गया विशाल और आरामदायक प्रतीक्षा क्षेत्र।",
    facilityEmergencyTitle: "आपातकालीन सेवाएं",
    facilityEmergencyDesc:
      "समर्पित ट्रॉमा टीम और जीवन-रक्षक उपकरणों के साथ 24/7 आपातकालीन चिकित्सा सहायता।",
    facilityReceptionTitle: "स्वागत कक्ष और फ्रंट डेस्क",
    facilityReceptionDesc:
      "अपॉइंटमेंट और प्रश्नों में आपकी सहायता के लिए मैत्रीपूर्ण और कुशल स्वागत कर्मचारी।",
    facilityTeamTitle: "विशेषज्ञ चिकित्सा दल",
    facilityTeamDesc:
      "अनुभवी गैस्ट्रोएंटेरोलॉजिस्ट और स्वास्थ्य सेवा पेशेवरों की समर्पित टीम।",
    facilityHduTitle: "एचडीयू और आईसीयू सुविधा",
    facilityHduDesc:
      "आधुनिक जीवन-रक्षक प्रणालियों से सुसज्जित उन्नत हाई डिपेंडेंसी यूनिट (HDU) और इंटेंसिव केयर यूनिट (ICU)।",
    facilityLabTitle: "24×7 प्रयोगशाला",
    facilityLabDesc:
      "त्वरित और सटीक नैदानिक रिपोर्ट के लिए चौबीसों घंटे उपलब्ध पूरी तरह से सुसज्जित प्रयोगशाला सेवाएं।",
    facilityPharmacyTitle: "24×7 फार्मेसी",
    facilityPharmacyDesc:
      "बिना देरी के आवश्यक दवाओं तक आसान पहुंच प्रदान करने वाली 24/7 खुली इन-हाउस फार्मेसी।",
    facilityParkingTitle: "निःशुल्क पार्किंग",
    facilityParkingDesc:
      "मरीजों और आगंतुकों के लिए निःशुल्क उपलब्ध विशाल और सुरक्षित पार्किंग सुविधा।",

    // Contact
    contactUs: "हमसे संपर्क करें",
    getDirections: "दिशा-निर्देश प्राप्त करें",
    india: "भारत",
    Address: "पता",
    Phone: "फोन",
    Email: "ईमेल",
    Hours: "समय",
    addressDetails:
      "श्री नाथ प्लाजा, मोहिंदरगढ़ - रेवाड़ी रोड, बस स्टैंड के सामने, ममराज कॉलोनी, महाराणा प्रताप नगर, नारनौल, हरियाणा 123001",
    phoneDetails: "+91 9996504991",
    emailDetails: "drashokgastrolivercentre@gmail.com",
    hoursDetails:
      "सोम-रविवार: 24/7 आपातकालीन सेवा उपलब्ध",

    // Book Appointment
    bookAppointmentTitle: "अपना अपॉइंटमेंट बुक करें",
    scheduleConsultation: "हमारे विशेषज्ञ डॉक्टरों के साथ परामर्श का समय निर्धारित करें",
    fullName: "पूरा नाम",
    emailAddress: "ईमेल पता",
    phoneNumber: "फोन नंबर",
    preferredDate: "पसंदीदा तारीख",
    preferredTime: "पसंदीदा समय",
    describeYourProblem: "अपनी समस्या का वर्णन करें",
    enterFullName: "अपना पूरा नाम दर्ज करें",
    enterEmail: "अपना ईमेल दर्ज करें",
    enterPhone: "अपना फोन नंबर दर्ज करें",
    enterProblem: "कृपया अपनी चिकित्सा स्थिति या चिंता का वर्णन करें",
    submit: "अपॉइंटमेंट बुक करें",
    backToHome: "होम पर वापस जाएं",
    appointmentBooked: "अपॉइंटमेंट सफलतापूर्वक बुक की गई!",
    bookingFailed: "अपॉइंटमेंट बुक करने में विफल",
    bookingError: "अपॉइंटमेंट बुक करने में त्रुटि: ",

    // Confirmation Popup
    confirmTitle: "अपनी अपॉइंटमेंट की पुष्टि करें",
    confirmMessage: "क्या आप वाकई यह अपॉइंटमेंट बुक करना चाहते हैं?",
    confirmYes: "हां, पुष्टि करें",
    confirmNo: "रद्द करें",
    successTitle: "अपॉइंटमेंट की पुष्टि हो गई!",
    successMessage:
      "आपकी अपॉइंटमेंट सफलतापूर्वक बुक हो गई है। हम जल्द ही विवरण की पुष्टि के लिए आपसे संपर्क करेंगे।",
    successClose: "ठीक है, समझ गया!",

    // Admin Login
    adminLogin: "प्रशासक लॉगिन",
    adminPortal: "प्रशासक पोर्टल",
    username: "उपयोगकर्ता नाम",
    password: "पासवर्ड",
    login: "लॉगिन करें",
    loggingIn: "लॉगिन हो रहे हैं...",
    invalidCredentials: "अमान्य उपयोगकर्ता नाम या पासवर्ड",
    demo: "डेमो",
    demoUsername: "admin",
    demoPassword: "admin123",
    backToLogin: "होम पर वापस जाएं",

    // Dashboard
    dashboard: "डैशबोर्ड",
    manageAppointments: "अपॉइंटमेंट प्रबंधित करें",
    logout: "लॉग आउट करें",
    loading: "अपॉइंटमेंट लोड हो रही हैं...",
    totalAppointments: "कुल अपॉइंटमेंट",
    confirmed: "पुष्टि की गई",
    pending: "लंबित",
    allAppointments: "सभी अपॉइंटमेंट",
    noAppointments: "अभी तक कोई अपॉइंटमेंट बुक नहीं की गई है।",
    name: "नाम",
    completed: "पूर्ण",
    cancelled: "रद्द",
    status: "स्थिति",
    action: "कार्रवाई",
    problem: "समस्या",
    time: "समय",
    date: "तारीख",
    noData: "कोई डेटा नहीं",

    // Footer
    excellenceInCare: "गैस्ट्रोएंटेरोलॉजी देखभाल में उत्कृष्टता",
    hospitalDescription:
      "पाचन स्वास्थ्य और लिवर रोगों के लिए व्यापक और दयालु देखभाल प्रदान करना।",
    quickLinks: "त्वरित लिंक",
    contactInfo: "संपर्क जानकारी",
    followUs: "हमें फॉलो करें",
    allRightsReserved: "सर्वाधिकार सुरक्षित।",
    privacyPolicy: "गोपनीयता नीति",
    termsOfService: "सेवा की शर्तें",
    disclaimer: "अस्वीकरण",
    footerTagline: "पाचन और लिवर स्वास्थ्य के लिए आपका विश्वसनीय साथी",
    copyright:
      "© 2025 डॉ. अशोक गैस्ट्रो और लिवर हॉस्पिटल। सर्वाधिकार सुरक्षित।",

    // Footer Hours Labels
    footerMonFri: "सोम – शुक्र",
    footerSaturday: "शनिवार",
    footerSunday: "रविवार",
    footerEmergency: "आपातकाल",
    footerEmergencyTime: "24 / 7",

    // Footer Brand
    footerBrandMain: "डॉ. अशोक गैस्ट्रो",
    footerBrandSub: "और लिवर हॉस्पिटल",
    footerCity: "नारनौल, हरियाणा 123001",

    // About Page
    aboutUs: "हमारे बारे में",
    aboutPageTitle: "डॉ. अशोक गैस्ट्रो और लिवर हॉस्पिटल के बारे में",
    aboutPageSubtitle: "नारनौल, हरियाणा में एक प्रमुख मल्टी-स्पेशलिटी गैस्ट्रोएंटेरोलॉजी केंद्र",
    missionTitle: "हमारा मिशन",
    missionText: "विश्व स्तरीय गैस्ट्रोएंटेरोलॉजी और लिवर देखभाल प्रदान करना जो सुलभ, दयालु और साक्ष्य-आधारित हो — यह सुनिश्चित करना कि प्रत्येक रोगी को सर्वोत्तम संभव परिणाम मिले।",
    visionTitle: "हमारी दृष्टि",
    visionText: "हरियाणा में सबसे विश्वसनीय गैस्ट्रोएंटेरोलॉजी केंद्र बनना, नैदानिक उत्कृष्टता, रोगी-केंद्रित देखभाल और पाचन स्वास्थ्य में निरंतर नवाचार के लिए मान्यता प्राप्त करना।",
    directorsMessage: "निदेशक का संदेश",
    directorsMessageFull: "डॉ. अशोक गैस्ट्रो और लिवर हॉस्पिटल में, हमारी प्रतिबद्धता बीमारियों के इलाज से परे है — हम लोगों की देखभाल करते हैं। हमारे दरवाजे से गुजरने वाले प्रत्येक रोगी को सहानुभूति और सम्मान के साथ उच्चतम मानक की चिकित्सा देखभाल मिलनी चाहिए।",
    directorsQuote: "हमारे मरीज हमारी प्राथमिकता हैं। हमारा हर निर्णय उनकी भलाई और विश्वास से निर्देशित होता है।",
    readFullMessage: "पूरा संदेश पढ़ें",
    valueExcellence: "उत्कृष्टता",
    valueExcellenceDesc: "नैदानिक देखभाल और रोगी सुरक्षा में अटूट मानक।",
    valueCompassion: "करुणा",
    valueCompassionDesc: "प्रत्येक रोगी के साथ सहानुभूति, गरिमा और सम्मान के साथ व्यवहार।",
    valueInnovation: "नवाचार",
    valueInnovationDesc: "नवीनतम चिकित्सा तकनीक और साक्ष्य-आधारित प्रथाओं को अपनाना।",
    valueIntegrity: "ईमानदारी",
    valueIntegrityDesc: "हमारी सभी बातचीत में ईमानदार, पारदर्शी और नैतिक।",
    accreditationsTitle: "मान्यताएं और पहचान",

    // Team Page
    teamPageTitle: "हमारी चिकित्सा टीम",
    teamPageSubtitle: "आपकी भलाई के लिए समर्पित स्वास्थ्य सेवा पेशेवरों की एक टीम",
    teamDoctorNote: "डॉ. अशोक कुमार की विस्तृत प्रोफ़ाइल के लिए, हमारे",
    teamDoctorPage: "डॉक्टर पेज",
    teamMedical: "चिकित्सा टीम",
    teamClinical: "क्लिनिकल सपोर्ट",
    teamPharmacy: "फार्मेसी",
    teamNursing: "नर्सिंग टीम",
    teamAdmin: "प्रशासन",
    teamSupport: "सहायक कर्मचारी",
    gastroIntensivist: "गैस्ट्रो इंटेंसिविस्ट",
    gastroIntensivistDesc: "गैस्ट्रोएंटेरोलॉजी रोगियों के लिए क्रिटिकल केयर प्रबंधन में विशेषज्ञ।",
    residentDoctor: "रेजिडेंट डॉक्टर",
    residentDoctorDesc: "चौबीसों घंटे चिकित्सा पर्यवेक्षण और रोगी देखभाल प्रदान करना।",
    otTechnician: "ओटी तकनीशियन",
    otTechnicianDesc: "ऑपरेशन थिएटर सेटअप और सर्जिकल सहायता में विशेषज्ञ।",
    labTechnician: "लैब तकनीशियन",
    labTechnicianDesc: "सटीक नैदानिक परीक्षण और प्रयोगशाला विश्लेषण करना।",
    pharmacist: "फार्मासिस्ट",
    pharmacistDesc: "दवाओं का सुरक्षित और सटीक वितरण सुनिश्चित करना।",
    nursingStaff: "नर्सिंग स्टाफ",
    nursingStaffDesc: "20+ समर्पित नर्सें दयालु बेडसाइड देखभाल प्रदान करती हैं।",
    generalManager: "जनरल मैनेजर",
    generalManagerDesc: "अस्पताल संचालन और प्रशासनिक कार्यों की देखरेख।",
    receptionist: "रिसेप्शनिस्ट",
    receptionistDesc: "मरीजों और आगंतुकों के लिए संपर्क का पहला बिंदु।",
    supportStaffDesc: "स्वच्छ, सुरक्षित वातावरण सुनिश्चित करने वाले हाउसकीपिंग, सुरक्षा और रखरखाव।",

    // Services Page
    servicesPageTitle: "हमारी सेवाएं",
    servicesPageSubtitle: "व्यापक गैस्ट्रोएंटेरोलॉजी और लिवर देखभाल सेवाएं",
    backToServices: "सेवाओं पर वापस जाएं",
    whatToExpect: "क्या उम्मीद करें",
    procedureSteps: "प्रक्रिया के चरण",
    benefits: "लाभ",
    bookNow: "अपॉइंटमेंट बुक करें",

    // Facilities Page
    facilitiesPageTitle: "हमारी सुविधाएं",
    facilitiesPageSubtitle: "विश्व स्तरीय देखभाल के लिए अत्याधुनिक बुनियादी ढांचा",
    backToFacilities: "सुविधाओं पर वापस जाएं",
    relatedFacilities: "संबंधित सुविधाएं",
    facilityFeatures: "मुख्य विशेषताएं",

    // Doctor Page
    doctorPageTitle: "डॉ. अशोक कुमार",
    doctorPageSubtitle: "MD (आंतरिक चिकित्सा), चंडीगढ़ · DM (गैस्ट्रोएंटेरोलॉजी), लुधियाना — वरिष्ठ सलाहकार और निदेशक",
    education: "शिक्षा",
    experience: "अनुभव",
    specializations: "विशेषज्ञताएं",
    awardsRecognition: "पुरस्कार और मान्यता",
    publications: "प्रकाशन और अनुसंधान",
    consultationSchedule: "परामर्श अनुसूची",
    proceduresPerformed: "की गई प्रक्रियाएं",
    bookConsultation: "परामर्श बुक करें",

    // Mission & Vision section on landing
    missionVisionTitle: "मिशन और दृष्टि",
    missionVisionSubtitle: "उद्देश्य से निर्देशित, उत्कृष्टता से प्रेरित",

    // Director Page
    directorsDesk: "निदेशक की मेज से",
    directorsMessageTitle: "निदेशक का संदेश",
    viewFullProfile: "पूरी प्रोफ़ाइल देखें",
    bookAppointmentBtn: "अपॉइंटमेंट बुक करें",
    dirMsgPara1: "डॉ. अशोक गैस्ट्रो और लिवर हॉस्पिटल में, हमारी प्रतिबद्धता नैदानिक उत्कृष्टता से परे है। हम मानते हैं कि प्रत्येक रोगी दयालु, पारदर्शी और साक्ष्य-आधारित देखभाल का हकदार है। हमारे समर्पित पेशेवरों की टीम यह सुनिश्चित करने के लिए अथक परिश्रम करती है कि प्रत्येक यात्रा आरामदायक, सम्मानजनक और प्रभावी हो।",
    dirMsgPara2: "पिछले 15 वर्षों में, हमें हरियाणा और पड़ोसी राज्यों से 1 लाख से अधिक रोगियों की सेवा करने का सौभाग्य मिला है। यह विश्वास हमारी सबसे बड़ी उपलब्धि और सुधार की हमारी सबसे मजबूत प्रेरणा है।",
    dirMsgPara3: "हम नवीनतम एंडोस्कोपिक तकनीक, चल रही चिकित्सा शिक्षा और रोगी-केंद्रित प्रक्रियाओं में निवेश करना जारी रखते हैं — क्योंकि आप सर्वश्रेष्ठ से कम के हकदार नहीं हैं।",
    dirClosingTitle: "MD (आंतरिक चिकित्सा) · DM (गैस्ट्रोएंटेरोलॉजी)",
    dirClosingRole: "निदेशक और वरिष्ठ सलाहकार, डॉ. अशोक गैस्ट्रो-लिवर हॉस्पिटल",

    // About Page
    ourStory: "हमारी कहानी",
    trustedNameTitle: "गैस्ट्रोएंटेरोलॉजी देखभाल में",
    gastroCareSub: "एक विश्वसनीय नाम",
    yearsOfExcellence: "उत्कृष्टता के वर्ष",
    yearsExperienceLbl: "वर्षों का अनुभव",
    patientsTreatedLbl: "उपचारित मरीज़",
    emergencyCareLbl: "आपातकालीन देखभाल",
    ourValuesEyebrow: "हमारे मूल्य",
    whatWeStandFor: "हम किसके लिए खड़े हैं",
    readyWorldClassCare: "विश्व स्तरीय देखभाल का अनुभव करने के लिए तैयार हैं?",
    bookConsultationToday: "आज ही डॉ. अशोक कुमार के साथ अपना परामर्श बुक करें।",
    callNowBtn: "अभी कॉल करें",
    aboutPara1: "डॉ. अशोक गैस्ट्रो और लिवर हॉस्पिटल नारनौल, हरियाणा में एक प्रमुख मल्टी-स्पेशलिटी गैस्ट्रोएंटेरोलॉजी केंद्र है। डॉ. अशोक कुमार (MD, DM गैस्ट्रोएंटेरोलॉजी) द्वारा स्थापित और नेतृत्व में, हम 15 से अधिक वर्षों से नवीनतम चिकित्सा तकनीक और साक्ष्य-आधारित प्रथाओं का उपयोग करके व्यापक पाचन और लिवर देखभाल प्रदान कर रहे हैं।",
    aboutPara2: "हमारा अस्पताल रोगी देखभाल, सुरक्षा और नैदानिक उत्कृष्टता के उच्चतम मानकों के प्रति प्रतिबद्ध है। हम क्षेत्र के प्रत्येक रोगी के लिए विश्व स्तरीय गैस्ट्रोएंटेरोलॉजी देखभाल सुलभ बनाने के लिए समर्पित हैं।",

    // Doctor Page
    academicQualifications: "शैक्षणिक योग्यताएं",
    achievementsMemberships: "उपलब्धियां और सदस्यताएं",
    consultationHours: "परामर्श समय",
    readyToConsult: "डॉ. अशोक कुमार से परामर्श के लिए तैयार हैं?",
    bookAppointmentToday: "आज ही अपॉइंटमेंट बुक करें और विशेषज्ञ गैस्ट्रोएंटेरोलॉजी देखभाल प्राप्त करें।",
    yearsExpLbl: "वर्षों का अनुभव",
    proceduresLbl: "प्रक्रियाएं",
    patientsLbl: "मरीज़",
    callNowAction: "अभी कॉल करें",
    ach1: "गैस्ट्रोएंटेरोलॉजी और हेपेटोलॉजी में 15+ वर्षों का समर्पित अभ्यास",
    ach2: "10,000+ से अधिक एंडोस्कोपिक प्रक्रियाएं की गई",
    ach3: "क्षेत्रीय CME कार्यक्रमों में नियमित वक्ता",
    ach4: "हरियाणा मेडिकल काउंसिल द्वारा रोगी देखभाल में उत्कृष्टता के लिए मान्यता प्राप्त",
    edu1Degree: "MBBS",
    edu1Inst: "गवर्नमेंट मेडिकल कॉलेज, रोहतक",
    edu2Degree: "MD – आंतरिक चिकित्सा",
    edu2Inst: "गवर्नमेंट मेडिकल कॉलेज और हॉस्पिटल, चंडीगढ़",
    edu3Degree: "DM – गैस्ट्रोएंटेरोलॉजी",
    edu3Inst: "दयानंद मेडिकल कॉलेज और हॉस्पिटल, लुधियाना",
    schMornType: "सुबह OPD",
    schEvenType: "शाम OPD",
    schSunType: "अपॉइंटमेंट द्वारा",
    schEmerType: "आपातकाल",
    schMonSat: "सोम – शनि",
    schSunday: "रविवार",
    schAllDays: "सभी दिन",

    // Team Page
    ourPeople: "हमारे लोग",
    ourTeamBreadcrumb: "हमारी टीम",
    healthcareTeamEyebrow: "स्वास्थ्य सेवा टीम",
    meetOurTeam: "हमारी टीम से मिलें",
    clickDeptHint: "सभी टीम सदस्यों को देखने के लिए विभाग पर क्लिक करें",
    memberSingular: "सदस्य",
    memberPlural: "सदस्य",
    clickViewMembers: "सभी सदस्य देखने के लिए क्लिक करें →",
    experienceCareTitle: "हमारी विशेषज्ञ टीम से देखभाल का अनुभव करें",
    experienceCareDesc: "अपॉइंटमेंट बुक करें और हमारे समर्पित पेशेवरों को आपकी देखभाल करने दें।",

    // Book Appointment Page
    appointmentsEyebrow: "अपॉइंटमेंट",
    bookAnAppointment: "अपॉइंटमेंट बुक करें",
    bookSubtitle: "डॉ. अशोक कुमार के साथ अपना परामर्श बुक करने का तरीका चुनें",
    instantBadge: "तत्काल",
    onlineBadge: "ऑनलाइन",
    callNowTitle: "अभी कॉल करें",
    callNowDesc: "अपनी अपॉइंटमेंट तुरंत बुक करने के लिए हमारी रिसेप्शन टीम से सीधे बात करें। क्लिनिक के समय उपलब्ध।",
    monSatHours: "सोम–रवि: सुबह 9 बजे – शाम 5 बजे | शाम 5–8 बजे OPD आपातकाल",
    emergency247: "आपातकाल: 24/7",
    callNumber: "+91 9996504991 पर कॉल करें",
    bookViaForm: "फॉर्म के माध्यम से बुक करें",
    bookViaFormDesc: "हमारा ऑनलाइन अपॉइंटमेंट फॉर्म भरें। हमारी टीम आपके अनुरोध की समीक्षा करेगी और स्वीकृत होने पर पुष्टि ईमेल भेजेगी।",
    step1Text: "अपनी जानकारी के साथ फॉर्म भरें",
    step2Text: "अनुरोध की समीक्षा व्यवस्थापक द्वारा की जाती है",
    step3Text: "आपको पुष्टि ईमेल भेजी जाती है",
    pendingStatus: "लंबित",
    confirmedStatus: "पुष्टि ✓",
    openBookingForm: "बुकिंग फॉर्म खोलें",
    formNote: "नए टैब में खुलता है · निःशुल्क · लॉगिन की आवश्यकता नहीं",
    opdHours: "OPD समय",
    opdHoursDetail: "सोम–रवि: सुबह 9–शाम 5 बजे | आपातकाल OPD: शाम 5–8 बजे",
    emergencyLabel: "आपातकाल",
    emergency247Available: "24/7 उपलब्ध",
    locationLabel: "स्थान",
    narnaul: "नारनौल, हरियाणा",

    // Team Dept Page
    backToTeam: "टीम पर वापस जाएं",
    ourTeamEyebrow: "हमारी टीम",
    otherDepartments: "अन्य विभाग",

    // Navbar & shared UI
    bookEAppointment: "ई-अपॉइंटमेंट बुक करें",
    emergencyColon: "आपातकाल:",
    callUs: "हमें कॉल करें",
    emergency: "आपातकाल",
    available247: "24/7 उपलब्ध",
    locationNav: "स्थान",
    narnaulHaryana: "नारनौल, हरियाणा",
    hospitalName: "डॉ. अशोक गैस्ट्रो-लिवर हॉस्पिटल",
    hospitalTagline: "एक मल्टी स्पेशलिटी गैस्ट्रोएंटेरोलॉजी हॉस्पिटल",
    allServicesArrow: "सभी सेवाएं ↓",
    allFacilitiesArrow: "सभी सुविधाएं ↓",
    aboutUs2: "हमारे बारे में",
    directorMessage: "निदेशक का संदेश",
    fromDrAshok: "डॉ. अशोक कुमार से",
    ourStoryMission: "हमारी कहानी और मिशन",
    upperGIExam: "ऊपरी GI जांच",
    colonScreening: "कोलन स्क्रीनिंग",
    bileDuctProc: "पित्त नली प्रक्रियाएं",
    tissueSampling: "ऊतक नमूनाकरण",
    bleedingControl: "रक्तस्राव नियंत्रण",
    safeRetrieval: "सुरक्षित वस्तु निष्कासन",
    stentTherapy: "स्टेंट प्लेसमेंट थेरेपी",
    feedingTube: "फीडिंग ट्यूब सम्मिलन",
    polypRemoval: "पॉलीप निष्कासन",
    bleedingClipping: "रक्तस्राव स्थल क्लिपिंग",
    ulcerTreatment: "अल्सर उपचार",
    narrowingCorrection: "संकुचन सुधार",
    advancedSurgical: "उन्नत शल्य चिकित्सा सुइट",
    privateConsult: "निजी परामर्श",
    patientLounge: "आरामदायक रोगी लाउंज",
    emergencyCare247: "24/7 आपातकालीन देखभाल",
    patientReg: "रोगी पंजीकरण",
    roundClockTesting: "चौबीसों घंटे परीक्षण",
    medicinesAvail: "दवाएं हमेशा उपलब्ध",
    freeParkingDesc: "निःशुल्क रोगी पार्किंग",
    allStaffMembers: "सभी कर्मचारी सदस्य",
    teamLabel: "टीम",
    doctorsLabel: "डॉक्टर",
    ourMedicalTeam: "हमारी चिकित्सा टीम",

    // LandingPage hardcoded
    yearsExperiencePill: "15+ वर्षों का अनुभव",
    heroTitlePart1: "विशेषज्ञ",
    heroTitleHighlight: "गैस्ट्रो और लिवर",
    heroTitlePart2: "देखभाल",
    heroTitlePart3: "जिस पर आप भरोसा कर सकते हैं",
    expertGastroTitle: "विशेषज्ञ गैस्ट्रो और लिवर देखभाल जिस पर आप भरोसा कर सकते हैं",
    heroHighlight: "गैस्ट्रो और लिवर",
    heroCareText: "जिस पर आप भरोसा कर सकते हैं",
    emergencyStatLbl: "आपातकाल",
    quickAppointment: "त्वरित अपॉइंटमेंट",
    bookEAppointmentBtn: "ई-अपॉइंटमेंट बुक करें",
    mdDmGastroTrust: "MD, DM गैस्ट्रोएंटेरोलॉजिस्ट",
    emergency247Services: "24/7 आपातकालीन सेवाएं",
    patientRating: "4.5/5 रोगी रेटिंग",
    yearsOfExcellenceBadge: "उत्कृष्टता के वर्ष",
    aboutUsEyebrow: "हमारे बारे में",
    trustedNameLanding: "गैस्ट्रोएंटेरोलॉजी देखभाल में",
    gastroCareLanding: "एक विश्वसनीय नाम",
    landingAboutPara1: "डॉ. अशोक गैस्ट्रो और लिवर हॉस्पिटल नारनौल, हरियाणा में एक प्रमुख मल्टी-स्पेशलिटी गैस्ट्रोएंटेरोलॉजी केंद्र है। डॉ. अशोक कुमार (MD, DM गैस्ट्रोएंटेरोलॉजी) के नेतृत्व में, हम नवीनतम चिकित्सा तकनीक का उपयोग करके व्यापक पाचन और लिवर देखभाल प्रदान करते हैं।",
    landingAboutPara2: "हमारा अस्पताल रोगी देखभाल, सुरक्षा और नैदानिक उत्कृष्टता के उच्चतम मानकों के प्रति प्रतिबद्ध है, हरियाणा और पड़ोसी राज्यों के रोगियों की सेवा करता है।",
    yearsExperienceStat: "वर्षों का अनुभव",
    patientsTreatedStat: "उपचारित मरीज़",
    advancedEndoscopy: "उन्नत एंडोस्कोपी सुइट",
    emergency24ICU: "24/7 आपातकाल और ICU",
    inhouseLab: "इन-हाउस लैब और फार्मेसी",
    compassionateCare: "दयालु रोगी देखभाल",
    learnMore: "और जानें",
    viewDetails: "विवरण देखें",
    learnMoreLink: "और जानें",
    patientTestimonialsEyebrow: "रोगी प्रशंसापत्र",
    whatPatientsSay: "हमारे मरीज़ क्या कहते हैं",
    viewAllGoogleReviews: "सभी Google समीक्षाएं देखें",
    googleReview: "Google समीक्षा",
    readyBookTitle: "अपनी अपॉइंटमेंट बुक करने के लिए तैयार हैं?",
    readyBookDesc: "डॉ. अशोक कुमार से विशेषज्ञ गैस्ट्रोएंटेरोलॉजी देखभाल प्राप्त करें। आपातकाल के लिए 24/7 उपलब्ध।",

    // ServiceDetailPage hardcoded
    ourServicesEyebrow: "हमारी सेवाएं",
    aboutThisProcedure: "इस प्रक्रिया के बारे में",
    bookThisProcedure: "यह प्रक्रिया बुक करें",
    scheduleConsultDesc: "विशेषज्ञ मूल्यांकन के लिए डॉ. अशोक कुमार के साथ परामर्श निर्धारित करें।",
    doctorSidebarTitle: "डॉक्टर",
    drAshokDeg: "MD (आंतरिक चिकित्सा) · DM (गैस्ट्रोएंटेरोलॉजी)",
    viewProfile: "प्रोफ़ाइल देखें",
    otherServicesTitle: "अन्य सेवाएं",

    // FacilityDetailPage hardcoded
    ourFacilitiesEyebrow: "हमारी सुविधाएं",

    // Footer hardcoded
    footerBrandName: "डॉ. अशोक गैस्ट्रो",
    footerBrandSub2: "और लिवर हॉस्पिटल",
    footerAboutUs: "हमारे बारे में",

    // Service subtitles
    endoscopySubtitle: "उन्नत निदान और चिकित्सीय एंडोस्कोपी",
    colonoscopySubtitle: "संपूर्ण कोलन जांच",
    ercpSubtitle: "एंडोस्कोपिक रेट्रोग्रेड कोलेंजियोपैंक्रियाटोग्राफी",
    biopsySubtitle: "सटीक ऊतक नमूनाकरण",
    varicealLigationSubtitle: "एंडोस्कोपिक बैंड लिगेशन",
    foreignBodyRemovalSubtitle: "एंडोस्कोपिक निष्कासन",
    enteralMetalStentingSubtitle: "सेल्फ-एक्सपैंडिंग मेटल स्टेंट प्लेसमेंट",
    pegPlacementSubtitle: "पर्क्यूटेनियस एंडोस्कोपिक गैस्ट्रोस्टॉमी",
    polypectomySubtitle: "एंडोस्कोपिक पॉलीप निष्कासन",
    hemoclipApplicationSubtitle: "एंडोस्कोपिक हेमोस्टेसिस",
    estUlcerSubtitle: "एंडोस्कोपिक स्क्लेरोथेरेपी",
    strictureDilatationSubtitle: "एंडोस्कोपिक डिलेटेशन थेरेपी",

    // Service descriptions
    endoscopyDesc: "ऊपरी GI एंडोस्कोपी (OGD स्कोपी) एक प्रक्रिया है जो लचीले कैमरे का उपयोग करके अन्नप्रणाली, पेट और ग्रहणी की जांच की अनुमति देती है।",
    colonoscopyDesc: "पॉलीप्स, कैंसर और सूजन आंत्र रोग का पता लगाने के लिए पूरे कोलन और मलाशय की व्यापक जांच।",
    ercpDesc: "पित्त नली और अग्नाशय की स्थितियों का निदान और उपचार करने के लिए एंडोस्कोपी और फ्लोरोस्कोपी को मिलाने वाली विशेष प्रक्रिया।",
    biopsyDesc: "सटीक रोग संबंधी निदान के लिए जठरांत्र संबंधी मार्ग से सुरक्षित और सटीक ऊतक नमूनाकरण।",
    varicealLigationDesc: "एसोफेजियल वैरिस से जीवन-घातक रक्तस्राव को नियंत्रित और रोकने के लिए प्रभावी एंडोस्कोपिक उपचार।",
    foreignBodyRemovalDesc: "पाचन तंत्र से गलती से निगली गई विदेशी वस्तुओं को सुरक्षित और कुशलतापूर्वक हटाना।",
    enteralMetalStentingDesc: "अन्नप्रणाली, पेट या कोलन में रुकावटों को दूर करने के लिए धातु स्टेंट का न्यूनतम आक्रामक प्लेसमेंट।",
    pegPlacementDesc: "दीर्घकालिक पोषण सहायता के लिए पेट में सीधे फीडिंग ट्यूब का एंडोस्कोपिक प्लेसमेंट।",
    polypectomyDesc: "कैंसर के विकास को रोकने के लिए जठरांत्र संबंधी मार्ग से असामान्य वृद्धि (पॉलीप्स) को हटाना।",
    hemoclipApplicationDesc: "जठरांत्र संबंधी रक्तस्राव को नियंत्रित करने के लिए विशेष क्लिप का उपयोग करने वाली सटीक एंडोस्कोपिक तकनीक।",
    estUlcerDesc: "पेप्टिक अल्सर से रक्तस्राव के उपचार और नियंत्रण के लिए उन्नत एंडोस्कोपिक इंजेक्शन थेरेपी।",
    strictureDilatationDesc: "निगलने और भोजन के मार्ग को बेहतर बनाने के लिए पाचन तंत्र के संकुचित हिस्सों को चौड़ा करने की प्रक्रिया।",

    // Service benefits - Endoscopy
    endoscopyD1: "अल्सर, गैस्ट्राइटिस, GERD का निदान",
    endoscopyD2: "H. pylori संक्रमण का पता लगाना",
    endoscopyD3: "कैंसर स्क्रीनिंग के लिए बायोप्सी",
    endoscopyD4: "रक्तस्राव घावों का उपचार",
    colonoscopyD1: "पॉलीप का पता लगाना और निष्कासन",
    colonoscopyD2: "कोलोरेक्टल कैंसर स्क्रीनिंग",
    colonoscopyD3: "IBD का निदान",
    colonoscopyD4: "मलाशय रक्तस्राव का मूल्यांकन",
    ercpD1: "पित्त नली की पथरी निष्कासन",
    ercpD2: "स्ट्रिक्चर के लिए स्टेंट प्लेसमेंट",
    ercpD3: "अग्नाशय विकारों का निदान",
    ercpD4: "पित्त अवरोध का उपचार",
    biopsyD1: "कैंसर निदान",
    biopsyD2: "H. pylori परीक्षण",
    biopsyD3: "सीलिएक रोग निदान",
    biopsyD4: "IBD मूल्यांकन",
    varicealD1: "आपातकालीन रक्तस्राव नियंत्रण",
    varicealD2: "पुनः रक्तस्राव की रोकथाम",
    varicealD3: "पोर्टल उच्च रक्तचाप प्रबंधन",
    varicealD4: "लिवर सिरोसिस जटिलता उपचार",
    foreignBodyD1: "सिक्का और बटन बैटरी निष्कासन",
    foreignBodyD2: "फूड बोलस इम्पैक्शन",
    foreignBodyD3: "तीखी वस्तु निष्कासन",
    foreignBodyD4: "बाल चिकित्सा और वयस्क मामले",
    enteralD1: "एसोफेजियल कैंसर उपशमन",
    enteralD2: "गैस्ट्रिक आउटलेट अवरोध",
    enteralD3: "कोलोनिक अवरोध राहत",
    enteralD4: "पित्त स्टेंटिंग",
    pegD1: "न्यूरोलॉजिकल स्थितियां",
    pegD2: "सिर और गर्दन का कैंसर",
    pegD3: "निगलने के विकार",
    pegD4: "दीर्घकालिक पोषण सहायता",
    polypD1: "कोलोरेक्टल पॉलीप निष्कासन",
    polypD2: "गैस्ट्रिक पॉलीप उच्छेदन",
    polypD3: "कैंसर की रोकथाम",
    polypD4: "हिस्टोपैथोलॉजिकल विश्लेषण",
    hemoclipD1: "पेप्टिक अल्सर रक्तस्राव",
    hemoclipD2: "पोस्ट-पॉलीपेक्टोमी रक्तस्राव",
    hemoclipD3: "डियूलाफॉय घाव",
    hemoclipD4: "मैलोरी-वेइस टियर",
    estD1: "सक्रिय रक्तस्राव अल्सर",
    estD2: "दृश्यमान वाहिका उपचार",
    estD3: "संयोजन थेरेपी",
    estD4: "पुनरावृत्ति की रोकथाम",
    strictureD1: "एसोफेजियल स्ट्रिक्चर",
    strictureD2: "अचलासिया उपचार",
    strictureD3: "पोस्ट-सर्जिकल स्ट्रिक्चर",
    strictureD4: "पेप्टिक स्ट्रिक्चर",

    // Team department titles
    deptMedical: "चिकित्सा टीम",
    deptOT: "OT",
    deptClinical: "लैब",
    deptPharmacy: "फार्मेसी",
    deptNursing: "नर्सिंग स्टाफ",
    deptAdmin: "प्रशासन",
    deptSupport: "सहायक स्टाफ",

    // Facility titles
    facilityOTFullTitle: "उन्नत ऑपरेशन थिएटर",
    facilityConsultFullTitle: "परामर्श कक्ष",
    facilityWaitingFullTitle: "मरीज़ प्रतीक्षा क्षेत्र",
    facilityEmergencyFullTitle: "आपातकालीन सेवाएं",
    facilityReceptionFullTitle: "स्वागत कक्ष और फ्रंट डेस्क",
    facilityLabFullTitle: "24x7 प्रयोगशाला",
    facilityPharmacyFullTitle: "24x7 फार्मेसी",
    facilityParkingFullTitle: "निःशुल्क पार्किंग",

    // Facility descriptions
    facilityOTFullDesc: "हमारा अत्याधुनिक ऑपरेशन थिएटर नवीनतम लेप्रोस्कोपिक और एंडोस्कोपिक तकनीक से सुसज्जित है।",
    facilityConsultFullDesc: "व्यापक रोगी मूल्यांकन और गोपनीय चर्चाओं के लिए डिज़ाइन किए गए निजी, सुसज्जित परामर्श कक्ष।",
    facilityWaitingFullDesc: "आरामदायक बैठने और रोगी शिक्षा सामग्री के साथ विशाल, वातानुकूलित प्रतीक्षा क्षेत्र।",
    facilityEmergencyFullDesc: "तत्काल गंभीर देखभाल के लिए समर्पित ट्रॉमा टीम और जीवन-रक्षक उपकरणों के साथ 24/7 आपातकालीन चिकित्सा सेवाएं।",
    facilityReceptionFullDesc: "आपकी यात्रा के दौरान अपॉइंटमेंट, प्रश्नों और रोगी मार्गदर्शन में सहायता के लिए प्रशिक्षित कर्मचारियों के साथ कुशल स्वागत।",
    facilityLabFullDesc: "त्वरित और सटीक नैदानिक रिपोर्ट के लिए स्वचालित विश्लेषकों के साथ पूरी तरह से सुसज्जित प्रयोगशाला।",
    facilityPharmacyFullDesc: "सभी आवश्यक दवाओं से भरी इन-हाउस फार्मेसी, आपकी सुविधा के लिए चौबीसों घंटे खुली।",
    facilityParkingFullDesc: "सभी मरीजों और आगंतुकों के लिए निःशुल्क उपलब्ध विशाल और सुरक्षित पार्किंग सुविधा।",

    // Facility features
    facilityOTF1: "लैमिनर एयरफ्लो सिस्टम",
    facilityOTF2: "उन्नत एनेस्थीसिया वर्कस्टेशन",
    facilityOTF3: "हाई-डेफिनिशन एंडोस्कोपी टॉवर",
    facilityOTF4: "आपातकालीन क्रैश कार्ट",
    facilityOTF5: "NABH मानकों के अनुसार स्टेरिलाइजेशन प्रोटोकॉल",
    facilityConsultF1: "डिजिटल रोगी रिकॉर्ड",
    facilityConsultF2: "हाई-रेजोल्यूशन डायग्नोस्टिक डिस्प्ले",
    facilityConsultF3: "निजी और गोपनीय वातावरण",
    facilityConsultF4: "मरीजों और परिचारकों के लिए आरामदायक बैठने की व्यवस्था",
    facilityWaitingF1: "वातानुकूलित आराम",
    facilityWaitingF2: "रोगी शिक्षा डिस्प्ले",
    facilityWaitingF3: "पीने के पानी की सुविधा",
    facilityWaitingF4: "व्हीलचेयर सुलभ",
    facilityEmergencyF1: "24/7 उपलब्धता",
    facilityEmergencyF2: "समर्पित ट्रॉमा टीम",
    facilityEmergencyF3: "उन्नत जीवन समर्थन",
    facilityEmergencyF4: "सीधी ICU पहुंच",
    facilityEmergencyF5: "एम्बुलेंस समन्वय",
    facilityReceptionF1: "अपॉइंटमेंट शेड्यूलिंग",
    facilityReceptionF2: "बीमा सहायता",
    facilityReceptionF3: "रोगी मार्गदर्शन",
    facilityReceptionF4: "बहुभाषी कर्मचारी",
    facilityLabF1: "स्वचालित विश्लेषक",
    facilityLabF2: "24/7 उपलब्धता",
    facilityLabF3: "त्वरित टर्नअराउंड समय",
    facilityLabF4: "डिजिटल रिपोर्ट डिलीवरी",
    facilityLabF5: "गुणवत्ता नियंत्रण प्रोटोकॉल",
    facilityPharmacyF1: "24/7 उपलब्धता",
    facilityPharmacyF2: "सभी आवश्यक दवाएं",
    facilityPharmacyF3: "जेनेरिक विकल्प उपलब्ध",
    facilityPharmacyF4: "प्रिस्क्रिप्शन सत्यापन",
    facilityParkingF1: "निःशुल्क",
    facilityParkingF2: "CCTV निगरानी",
    facilityParkingF3: "व्हीलचेयर सुलभ प्रवेश",
    facilityParkingF4: "वाहनों के लिए पर्याप्त स्थान",
  },
};

// Function to get translation
export const getTranslation = (language, key) => {
  return translations[language]?.[key] || translations.en[key] || key;
};

// Function to get all translations for a language
export const getLanguageTranslations = (language) => {
  return translations[language] || translations.en;
};